<script lang="ts">
  import { page } from '$app/stores';

  import { NavLink } from '@shared/ui/nav-link';

  import { navigationLinks, getLinkVisibility } from '../libs';

  $: hasAuctions = $page.data.institutionAuctionsCount > 0;
  $: hasArtists = $page.data.institutionArtistsCount > 0;
  $: hasNews = $page.data.institutionNewsCount > 0;
  $: hasCurators = $page.data.institutionCuratorsCount > 0;
  $: hasSelections = $page.data.institutionSelectionsCount > 0;
</script>

<ul class="flex items-center gap-9 lg:gap-5 xl:gap-6">
  {#each navigationLinks as { title, link }}
    {@const isVisible = getLinkVisibility(title, { hasAuctions, hasArtists, hasNews, hasCurators, hasSelections })}

    {#if isVisible}
      <li>
        <NavLink props="{{ href: `${link}/`, class: 'font-medium text-[15px]' }}">
          {title}
        </NavLink>
      </li>
    {/if}
  {/each}
</ul>
